module.exports = __webpack_public_path__ + "static/media/cncMilling.affbcbfe.jpg";